import { render, staticRenderFns } from "./EmployeeDocumentsEditCreate.vue?vue&type=template&id=c8c513f6&"
import script from "./EmployeeDocumentsEditCreate.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocumentsEditCreate.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeDocumentsEditCreate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmployeeDocumentsEditCreate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports